export function isListOperator(operator: string) {
	return operator == 'multiselect_equals' || operator == 'multiselect_not_equals';
}
